import "material-design-icons-iconfont/dist/material-design-icons.css";

import Vue from "vue";
import Plugins from "./plugins";
import Layout from "./views/Layout";

const plugins = new Plugins();
const config = plugins.setup(Vue, {render: (h) => h(Layout)});

Vue.prototype.$UPLOADCARE_PUB_KEY = process.env.VUE_APP_UPLOADCARE_KEY;

const app = new Vue(config).$mount("#root");
window.app = app;